import React from 'react';

const Navbar: React.FC = () => {
  return null;
};

export default Navbar;
